import React from "react"

import { useTranslation } from "@bounce/i18n"

import { Benefits } from "./components/Benefits"
import { FAQs } from "./components/FAQs"
import { Hero } from "./components/Hero"
import { MetricsList } from "./components/MetricsList"
import { useSEO } from "./hooks/useSEO"
import { ReviewsSlider } from "../../../components/Generic/Reviews/ReviewsSlider/ReviewsSlider"
import DynamicAppBannerSecondary from "../../../components/LuggageStorage/AppBanner/DynamicAppBannerSecondary"
import { HowItWorks } from "../../../components/LuggageStorage/HowItWorks/HowItWorks"
import { Layout } from "../../../components/LuggageStorage/Layout/Layout"
import { useGenericInterpolations } from "../../../hooks/useGenericInterpolations"
import type { Country } from "../../../libs/bounce/bounceSdk.types.gen"
import { useUrl } from "../../../libs/router"

export type AppDownloadScreenProps = {
  countries: Country[]
}

const AppDownloadScreen = ({ countries }: AppDownloadScreenProps) => {
  const [t] = useTranslation("marketing-ls-app")
  const { absolutePath } = useUrl()
  const interpolations = useGenericInterpolations({ countries })
  const { metaTitle, metaDescription } = useSEO()

  return (
    <Layout
      headProps={{
        title: metaTitle,
        description: metaDescription,
        url: absolutePath,
      }}
      from="AppDownload">
      <Hero interpolations={interpolations} />
      <MetricsList className="pb-section" />
      <ReviewsSlider
        title={t("cmp.reviewsSlider.favoriteApp", "Your new favorite luggage storage app")}
        showAppReviews
        name="ReviewsSliderAppDownload"
      />
      <Benefits interpolations={interpolations} className="mb-44 mt-24" />
      <HowItWorks variant="app-download" from="AppDownload" />
      <DynamicAppBannerSecondary name="AppBannerSecondaryAppDownload" />
      <FAQs />
    </Layout>
  )
}

export default AppDownloadScreen
